// ล้าง session ตอน logout / token หมดอายุ โดย "คง config ของเว็บ" ไว้
// (ถ้า clear ทั้งหมด setting จะหาย → Auth.svelte อ่าน dataSetting=null แล้ว crash เป็นหน้าขาว)
const KEEP = ['setting', 'appid', 'apiurl', 'registerid'];

export function clearSession() {
  const saved = {};
  KEEP.forEach((k) => {
    const v = window.localStorage.getItem(k);
    if (v !== null) saved[k] = v;
  });
  window.localStorage.clear();
  Object.keys(saved).forEach((k) => window.localStorage.setItem(k, saved[k]));
}
